export default {
    page_title: "Kevi | Usuários",
    title: "Usuários",
    subtitle: "Quem acessa o Kevi Marketing.",
    add: "Adicionar usuário",
    search: "Buscar por nome ou e-mail",
    columns: {
        user: "Usuário",
        contact: "Contato",
        phone: "Telefone",
        twofa: "Aut. 2FA",
        last_access: "Último acesso",
        actions: "Ações",
    },
    twofa_on: "Ativado",
    twofa_off: "Desativado",
    no_email: "Sem e-mail",
    no_phone: "Sem telefone",
    no_contact: "Sem e-mail e telefone.",
    unverified: "Não verificado",
    unused: "Fora de uso",
    tooltip_mkt: "Esta pessoa acessa a Kevi Marketing.",
    tooltip_chat: "Esta pessoa acessa a Kevi Chat.",
    tooltip_email_pending: "E-mail não verificado. Enquanto estiver pendente, não serve para redefinir a senha.",
    tooltip_phone_pending: "Telefone não verificado. Enquanto estiver pendente, não serve para redefinir a senha.",
    tooltip_no_contact: "Sem e-mail e sem telefone. Esta pessoa não consegue redefinir a própria senha.",
    today: "Hoje {0}",
    yesterday: "Ontem {0}",
    never: "Nunca acessou",
    empty: "Nenhum usuário encontrado",
    empty_hint: "Adicione quem vai acessar o Kevi Marketing.",
    empty_filters: "Nada corresponde a esses filtros.",
    loading: "Carregando usuários...",
    clear_filters: "Limpar filtros",
    reload: "Recarregar",
    load_error: "Não foi possível carregar os usuários.",
    load_error_hint: "A conexão falhou. Tente de novo em alguns instantes.",
    filters: {
        products: "Aplicativos vinculados",
        twofa: "Autenticação 2FA",
        contacts: "Contatos",
        marketing: "Kevi Marketing",
        chat: "Kevi Chat",
        email_verified: "E-mail verificado",
        email_pending: "E-mail pendente",
        no_email: "Sem e-mail",
        phone_verified: "Telefone verificado",
        phone_pending: "Telefone pendente",
        no_phone: "Sem telefone",
    },
    menu: {
        edit_profile: "Editar perfil",
        edit_permissions: "Editar permissões",
        set_password: "Definir nova senha",
        deactivate: "Desativar usuário",
    },
    password_modal: {
        title: "Digite sua senha de administrador",
        subtitle: "Por segurança, ações que afetam outros usuários pedem sua senha.",
        label: "Senha atual",
        close: "Fechar",
        continue: "Continuar",
        submitting: "Validando...",
        wrong: "A senha de administrador não confere.",
        failed: "Não foi possível concluir. Tente de novo.",
        too_many: "Muitas tentativas com a senha. Aguarde alguns minutos e tente de novo.",
    },
    create: {
        title: "Criar usuário",
        step_user: "Usuário",
        step_permissions: "Permissões",
        name: "Nome completo",
        searching: "Buscando usuários semelhantes...",
        found: "{0} usuários semelhantes encontrados",
        found_one: "1 usuário semelhante encontrado",
        none: "Nenhum usuário encontrado",
        none_hint: "Crie um usuário novo com esse nome.",
        failed_title: "Não foi possível buscar",
        failed: "Não deu para verificar usuários parecidos. Você ainda pode criar um novo e revisar depois.",
        create_named: "Criar usuário {0}",
        existing: "Usuários existentes",
        view_profile: "Ver perfil",
        link: "Vincular usuário",
        recover: "Recuperar usuário",
        import: "Importar usuário",
        linking: "Vinculando usuário · Kevi Chat > Kevi Marketing",
        photo_add: "Adicionar foto",
        photo_change: "Alterar foto",
        photo_edit: "Editar foto",
        username: "Usuário",
        username_placeholder: "Digite um usuário válido",
        password: "Senha",
        repeat: "Repetir senha",
        email: "E-mail",
        email_placeholder: "Digite um e-mail para esse usuário",
        phone: "Telefone",
        phone_placeholder: "Digite um telefone para esse usuário",
        product_marketing: "Acesso ao Kevi Marketing",
        product_chat: "Acesso ao Kevi Chat",
        yes: "Sim",
        no: "Não",
        back: "Voltar",
        next: "Próximo",
        need_name: "Informe o nome completo (mín. 3 caracteres).",
        need_username: "Informe um usuário válido (mín. 3 caracteres).",
        need_password: "Defina uma senha com pelo menos 8 caracteres.",
        need_password_match: "A senha e a confirmação precisam ser iguais.",
        submit: "Criar usuário",
        success: "Usuário criado com sucesso!",
        linked: "Usuário vinculado com sucesso!",
        linked_note: "O mesmo login e senha valem para a Kevi MKT e a Kevi Chat.",
        no_contact_title: "Criar sem e-mail ou telefone?",
        no_contact_body: "Sem um contato, este usuário não vai conseguir redefinir a própria senha.",
        continue_anyway: "Continuar mesmo assim",
        another: "Criar outro",
        done: "Concluir",
        taken: "Este dado já está em uso por {0}. Volte à busca para vincular ou recuperar.",
        permissions_title: "Permissões do Kevi Marketing",
        permissions_subtitle: "Controle o acesso a cobrança, à gestão de usuários e aos módulos deste produto.",
        billing: "Cobrança",
        billing_help: "Acessa conta, faturas, planos e pagamentos.",
        users: "Usuários",
        users_help: "Gerencia usuários e permissões de outros usuários.",
        modules: "Módulos",
        linking_label: "Vinculando usuário",
        importing_label: "Importando usuário",
        recovering_label: "Recuperando usuário desativado",
        back_to_search: "Voltar à busca",
        reason_empty: "é obrigatório",
        reason_small: "é muito curto",
        reason_invalid: "é inválido",
        reason_taken: "já está em uso",
    },
    edit: {
        title: "Editando usuário",
        load_error_title: "Não foi possível carregar este usuário",
        load_error_body: "O perfil pode ter sido removido ou a conexão falhou. Tente de novo ou volte para a lista.",
        permissions: "Editar permissões",
        password: "Editando senha",
        back: "Voltar",
        save: "Alterar",
        apply: "Aplicar",
        change_password: "Alterar senha",
        new_password: "Digite a nova senha",
        repeat: "Repita a nova senha",
        show: "Mostrar senha",
        hide: "Ocultar senha",
        contact_title: "Você alterou os dados de um usuário ativo",
        contact_body: "O usuário precisará confirmar os dados de contato após essa alteração.",
        contact_back: "Voltar",
        contact_continue: "Continuar mesmo assim",
        sessions_title: "Você alterou os dados de um usuário ativo",
        sessions_body: "Se deslogar, as sessões abertas são encerradas e a pessoa precisa entrar com a nova senha.",
        keep_sessions: "Salvar sem deslogar",
        end_sessions: "Deslogar de todos dispositivos",
        toast_kept: "Senha alterada. As sessões abertas foram mantidas.",
        toast_ended: "Senha alterada. Os dispositivos foram deslogados.",
        saved: "Alterações salvas.",
        taken_field: "Esse {0} já está em uso por outro usuário.",
    },
    deactivate: {
        title: "Desativar usuário?",
        body: "O usuário perde o acesso ao Kevi Marketing na hora e deixa de contar no plano.",
        chat: "O acesso à Kevi Chat continua. Para encerrar, desative também por lá.",
        cancel: "Cancelar",
        confirm: "Desativar usuário",
        done: "Usuário desativado",
        self: "Você não pode desativar a própria conta.",
        protected: "Este usuário é protegido e não pode ser alterado aqui.",
        failed: "Não foi possível desativar. Tente de novo.",
        last_admin: "A conta precisa de pelo menos um usuário com a permissão Usuários.",
        self_permission: "Você não pode tirar a própria permissão Usuários.",
    },
    profile: {
        title: "Meu perfil",
        personal: "Dados pessoais",
        personal_help: "Como seu nome aparece para a equipe e nas conversas com clientes.",
        change: "Alterar",
        security: "Segurança",
        security_help: "Como você recupera sua conta e protege seu acesso.",
        warning_title: "Adicione proteção a mais para sua conta",
        warning_body: "Complete os itens pendentes abaixo. Eles garantem que você recupere o acesso sozinho e deixam sua conta mais segura.",
        recovery: "Formas de recuperação",
        recovery_help: "Enviamos o código de redefinição de senha para os contatos verificados aqui.",
        verified: "Verificado",
        unverified: "Não verificado",
        inactive: "Inativa",
        active: "Ativa",
        add_email: "Adicionar e-mail",
        add_phone: "Adicionar telefone",
        change_email: "Alterar e-mail",
        change_email_button: "Alterar",
        verify: "Verificar",
        no_phone: "Nenhum telefone adicionado",
        twofa: "Autenticação de dois fatores",
        twofa_help: "Depois da senha, pedimos um código do app autenticador.\nProtege sua conta mesmo se a senha vazar.",
        enable: "Ativar",
        disable: "Desativar",
        password: "Senha",
        password_changed: "Alterada em {0}.",
        password_unknown: "Altere sua senha quando quiser.",
        change_password: "Alterar senha",
        password_rule: "Use pelo menos 8 caracteres.",
        note: "Pedimos sua senha atual sempre que você altera algo nesta tela.",
        logout_title: "Sair da conta",
        logout_help: "Você será desconectado apenas deste dispositivo.",
        logout: "Sair",
        name_title: "Alterar nome",
        current_password: "Senha atual",
        cancel: "Cancelar",
        send_code: "Enviar código",
        your_email: "Seu e-mail",
        confirm_email: "Confirme seu e-mail",
        your_phone: "Seu telefone",
        confirm_phone: "Confirme seu telefone",
        add_email_help: "Enviamos um código para confirmar que o e-mail é seu. Ele será usado para redefinir sua senha.",
        add_phone_help: "Enviamos um código por SMS para confirmar que o telefone é seu. Ele será usado para redefinir sua senha.",
        change_email_help: "O novo e-mail só passa a valer depois de verificado. Até lá, o atual continua sendo usado para recuperação.",
        change_phone_help: "O novo telefone só passa a valer depois de verificado. Até lá, o atual continua sendo usado para recuperação.",
        code_title: "Digite o código",
        code_help: "Enviamos um código de 6 dígitos para {0}.",
        code_sms: "Enviamos um código de 6 dígitos por SMS para {0}.",
        resend_in: "Não recebeu? Reenviar em {0}",
        resend: "Reenviar código",
        confirm: "Confirmar",
        invalid_code: "Código inválido ou expirado. Peça um novo código.",
        email_toast: "E-mail verificado",
        email_toast_body: "Agora você consegue redefinir sua senha por e-mail.",
        email_changed_toast: "E-mail alterado",
        email_changed_toast_body: "Agora você consegue redefinir sua senha por esse e-mail.",
        phone_toast: "Telefone verificado",
        phone_toast_body: "Agora você consegue redefinir sua senha por telefone.",
        password_title: "Alterar senha",
        new_password: "Nova senha",
        repeat_password: "Repita a nova senha",
        change_password_button: "Alterar senha",
        password_toast: "Senha alterada.",
        confirm_password_title: "Confirme sua senha",
        confirm_password_help: "Para ativar a autenticação de dois fatores, confirme que é você.",
        continue: "Continuar",
        qr_title: "Escaneie o QR code",
        qr_step: "Passo 1 de 3",
        qr_help: "Abra seu app autenticador (Google Authenticator, Authy, 1Password) e escaneie o código.",
        manual_key: "Não consegue escanear? Use a chave abaixo no seu app.",
        copy: "Copiar",
        copied: "Copiado",
        code_step: "Passo 2 de 3",
        app_code: "Digite o código do app",
        app_code_help: "Informe os 6 dígitos que aparecem no seu app autenticador.",
        app_code_hint: "O código muda a cada 30 segundos.",
        app_code_error: "Código inválido ou expirado. Tente novamente.",
        activate: "Ativar",
        codes_step: "Passo 3 de 3",
        codes_title: "Autenticação de dois fatores ativada",
        codes_help: "Guarde seus códigos de recuperação. Cada código funciona uma vez e é a única forma de entrar se você perder o app.",
        copy_codes: "Copiar códigos",
        download: "Baixar .txt",
        saved_codes: "Guardei meus códigos",
        disable_title: "Desativar autenticação de dois fatores?",
        disable_body: "Confirme sua senha para desativar.",
        disable_button: "Desativar 2FA",
        disabled_title: "Autenticação de dois fatores desativada",
        disabled_body: "Só a senha protege sua conta agora. Você pode ativar a autenticação de dois fatores quando quiser.",
        enable_again: "Ativar Autenticação 2FA novamente",
        close: "Fechar",
        disabled_toast: "Autenticação 2FA desativada!",
        disabled_toast_body: "Recomendamos que ative novamente assim que possível.",
        wrong_password: "Senha incorreta.",
        mismatch: "A senha e a confirmação não estão iguais. Volte e confira os dois campos.",
        contact_mismatch: "Os campos de confirmação não estão iguais. Confira e tente de novo.",
        invalid_phone: "Telefone inválido. Use DDD + número.",
        send_failed: "Não foi possível enviar o código. Tente de novo.",
        too_many: "Muitas tentativas. Aguarde alguns minutos e tente de novo.",
        photo_saved: "Foto atualizada.",
        photo_failed: "Não foi possível atualizar a foto. Tente de novo.",
        taken: "Este contato já está em uso.",
        disable_warning: "Sua conta volta a depender só da senha. Os códigos de recuperação deixam de funcionar.",
        change_phone: "Alterar telefone",
        verify_email: "Confirmar e-mail",
        verify_phone: "Confirmar telefone",
        verify_email_help: "Enviamos um código para o e-mail cadastrado. Ele será usado para redefinir sua senha.",
        verify_phone_help: "Enviamos um código por SMS para o telefone cadastrado. Ele será usado para redefinir sua senha.",
        phone_placeholder: "(99) 9 9999-9999",
        phone_changed_toast: "Telefone alterado",
        phone_changed_toast_body: "Agora você consegue redefinir sua senha por esse novo telefone.",
        name_help: "É assim que seu nome aparece para a equipe e nas conversas com clientes.",
        name_required: "Informe seu nome completo.",
        name_toast: "Nome completo alterado.",
        save: "Salvar",
        too_many_attempts: "Muitas tentativas com a senha. Aguarde alguns minutos e tente de novo.",
        generic_error: "Não foi possível concluir. Tente de novo.",
        invalid_email: "E-mail inválido. Confira e tente de novo.",
        missing_contact: "Não há contato cadastrado para confirmar.",
        code_expired: "O código expirou. Peça um novo código.",
        code_too_many: "Muitas tentativas com este código. Peça um novo código.",
        twofa_restart: "O tempo para ativar acabou. Confirme sua senha de novo.",
        twofa_too_many: "Muitas tentativas com o código. Confirme sua senha e comece de novo.",
        qr_alt: "QR code para o app autenticador",
    },
    prompt: {
        no_contact_title: "Sua conta não pode ser recuperada",
        no_contact_body: "Você ainda não tem e-mail nem telefone verificado. Se esquecer sua senha, só um administrador da sua empresa consegue redefinir o acesso para você.",
        email_title: "Confirme seu e-mail",
        email_body: "O e-mail {0} foi cadastrado pela sua empresa, mas ainda não foi confirmado. Até você confirmar, só um administrador consegue redefinir sua senha.",
        phone_title: "Confirme seu telefone",
        phone_body: "O telefone {0} foi cadastrado pela sua empresa, mas ainda não foi confirmado. Até você confirmar, só um administrador consegue redefinir sua senha.",
        add_phone: "Adicionar telefone",
        add_email: "Adicionar e-mail",
        other_email: "Usar outro e-mail",
        confirm_email: "Confirmar e-mail",
        other_phone: "Usar outro telefone",
        confirm_phone: "Confirmar telefone",
        later: "Agora não",
    },
};
